var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIDownload = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -180.564)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 180.564)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.135 84.613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-12.955,107.721a.494.494,0,0,1-.354-.148l-3.239-3.256a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l2.886,2.9,2.921-2.9a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-3.275,3.256A.5.5,0,0,1-12.955,107.721Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.955,107.7a.5.5,0,0,1-.5-.5V97.451a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V107.2A.5.5,0,0,1-12.955,107.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8.866,110.163h-8.141a2.13,2.13,0,0,1-2.128-2.128v-3.664a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.664a1.129,1.129,0,0,0,1.128,1.128h8.141a1.13,1.13,0,0,0,1.129-1.128v-3.664a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v3.664A2.13,2.13,0,0,1-8.866,110.163Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_download.b2000b95.svg";
export { ForwardRef as ReactComponent };